module.exports = __webpack_public_path__ + "static/img/IE.3707578.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/countries/IE.svg
// module id = fFnv
// module chunks = 1